import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-plant-toggle',
    imports: [MatButtonModule, MatDialogModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <h2 mat-dialog-title>{{ data.plantOwner }}</h2>
        <mat-dialog-content>
            {{
                (data.disabled
                    ? 'Are you sure you want to enable this plant for this user?'
                    : 'Are you sure you want to disable this plant for this user?'
                ) | translate
            }}
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button mat-button (click)="dialogRef.close(false)">
                {{ 'Cancel' | translate }}
            </button>
            <button mat-button cdkFocusInitial (click)="dialogRef.close(true)">
                {{ 'Confirm' | translate }}
            </button>
        </mat-dialog-actions>
    `
})
export class ConfirmPlantToggleComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { plantOwner: string; disabled: boolean },
        public dialogRef: MatDialogRef<ConfirmPlantToggleComponent>
    ) {}
}
